// extracted by css-extract-rspack-plugin
export default {"root":"IQViK","searchInput":"MRXrs","noBreakoutSection":"yOwa4","noBreakoutButton":"mnSBt","selected":"TRdFU","noBreakoutIcon":"cEFoK","noBreakoutLabel":"GnVBW"};